import { module } from 'angular';

import { DatePickerDirectiveAjs, default as datePickerDirectiveName } from './date-picker.directive.ajs';

export default module('contact.commons.toolbox.date-picker', []).directive(datePickerDirectiveName, DatePickerDirectiveAjs).name;
